module.exports = __webpack_public_path__ + "media/common/icon-check-circle-943225ce.svg";